The details of the uploaded candidate.

The uploaded candidate profile is available in the `profiles` field.
